'use strict';

export function routerDecorator($rootScope, $location, $state, Auth) {
  'ngInject';
  // Redirect to login if route requires auth and the user is not logged in, or doesn't have required role
  $rootScope.$on('$stateChangeStart', function(event, next, current) {
    if(!next.authenticate) {
      return;
    }

    if(typeof next.authenticate === 'string') {
      Auth.hasRole(next.authenticate).then(has => {
        if(has) {
          return;
        }

        event.preventDefault();

        // Go always to the login in the homepage
        $location.path('/'+ current.lang +'/');
        return;
        // return $state.go('main');
        // return Auth.isLoggedIn().then(is => {
          // $state.go(is ? 'terrapp.main' : 'terrapp.login');
        // });
      });
    } else {
      Auth.isLoggedIn().then(is => {
        if(is) {
          return;
        }

        event.preventDefault();

        // $state.go('terrapp.login');
        $state.go('main');
      });
    }
  });
};



// WEBPACK FOOTER //
// ./client/components/auth/router.decorator.ts